import React, { useState } from "react";
import moment from "moment";
import { Row, Col, Button } from "react-bootstrap";

import { toPesoAmount } from "../../helpers";
import AreaWidget from "../../components/widgets/AreaWidget";
import ItemRanking from "../../components/widgets/ItemRanking";
import { DB_DATE_FORMAT, PRIMARY_COLOR } from "../../constants";
import SalesByFulfillmentCard from "./SalesByFulfillmentCard";
import CustomerMix from "./CustomerMix";
import SalesPerItemCard from "./SalesPerItemCard";
import { CardListByReferrer, CardList } from "./CardList";
import Swal from "sweetalert2";
import { generatePickupPhLink } from "../../helpers";
import withReactContent from "sweetalert2-react-content";

const AnalyticsGrid = (props) => {
  const MySwal = withReactContent(Swal);

  const [isLoading, setIsLoading] = useState(false);
  const [excludeDeliveryFee, setExcludeDeliveryFee] = useState(true);
  const { data = {}, params = {} } = props;

  const { totalSales = 0 } = data;

  const cardListItemImgStyling = { maxHeight: "3rem" };

  const store_options =
    props.selectedBrand.attr === "brand"
      ? props.selectedBrand.stores?.map((store) => {
          return { label: store.name, value: store.id };
        })
      : [];

  const onSourceNameSubmit = async (name, stores, refetch) => {
    const { data } = props;
    const { allBrands = [], allStores = [] } = data;
    let url = "";
    let body = { name };
    const isBrand = props.selectedBrand.attr === "brand";

    if (isBrand) {
      const data_analytics = props.isMulti ? allBrands : allStores;

      const brand = data_analytics.filter(
        (brand) => brand.name === props.selectedBrand.name,
      );

      url = `/brand/${brand[0].id}/add-utm-source`;
      body = { ...body, stores };
    } else {
      const store = props.selectedBrand;
      url = `/store/${store.id}/add-utm-source`;
    }

    setIsLoading(true);

    props.api
      .post({
        url,
        data: body,
      })
      .then(({ data }) => {
        if (data && data.result === "ok") {
          const link = `${generatePickupPhLink(
            props.brand_url,
            false,
          )}?utm_campaign=${name}`;

          MySwal.fire({
            icon: "success",
            title: "Success!",
            html: (
              <div>
                <p>You have successfully saved your changes!</p>
                <p>
                  Here is your link: <br />
                  <a href={`https://${link}`} target="_blank">
                    {link}
                  </a>
                </p>
                <Button
                  onClick={() =>
                    navigator.clipboard.writeText("https://" + link)
                  }
                  variant="primary"
                >
                  Copy Link
                </Button>
              </div>
            ),
            confirmButtonColor: PRIMARY_COLOR,
            confirmButtonText: "Done",
          });
          setIsLoading(false);
          if (refetch) refetch();
        }
      })
      .catch((err) => {
        if (err) {
          MySwal.fire({
            icon: "error",
            title: "Ooops!",
            text: "Something went wrong" || err.message,
            confirmButtonColor: PRIMARY_COLOR,
            confirmButtonText: "OK",
            showCancelButton: false,
          });
        }
      });
  };

  return (
    <>
      <div className="">
        <Row className="align-items-stretch ml-0">
          <Col sm={12} lg={8} className="analytics-card">
            <SalesByFulfillmentCard
              params={params}
              excludeDeliveryFee={excludeDeliveryFee}
              setExcludeDeliveryFee={setExcludeDeliveryFee}
            />
          </Col>
          <Col sm={12} lg={4} className="px-0 px-lg-4">
            <AreaWidget
              className="card card-custom px-0 mt-2 mt-lg-0 total-sales-for-today"
              id="total-sales-for-today"
              header={"Total Sales for"}
              displayData={totalSales}
              view={"total-sales"}
              seriesName="Item Sold"
              seriesAttr="total"
              params={params}
              height={290}
              hasDropDown={false}
              customOptions={{
                stroke: {
                  show: true,
                  curve: "smooth",
                  lineCap: "round",
                  width: 0,
                },
                tooltip: {
                  y: {
                    formatter: function (
                      value,
                      { series, seriesIndex, dataPointIndex, w },
                    ) {
                      return value + " items";
                    },
                  },
                  custom: function ({
                    series,
                    seriesIndex,
                    dataPointIndex,
                    w,
                  }) {
                    let categoryLabel =
                      w.globals.categoryLabels[dataPointIndex];
                    categoryLabel =
                      categoryLabel < 10 ? "0" + categoryLabel : categoryLabel; // expects  2 digits or moment will return an invalid date

                    const header = moment(
                      `${moment().format(DB_DATE_FORMAT)} ${categoryLabel}`,
                    ).format("ha");

                    return `
                        <div class="barContainer">
                            <h5 class="barHeader">${header}</h5>

                            <div class="barContent">
                                ${w.globals.seriesNames.reduce(
                                  (acc, cur, i) => {
                                    return `${acc}  <div class="barSeriesContent">
                                        <span class="barBadge" style="background-color: ${w.globals.colors[i]}"></span>
                                        <span>${cur}</span>
                                        <span class='barData'>${series[i][dataPointIndex]} items</span>
                                    </div>`;
                                  },
                                  "",
                                )}
                            </div>
                        </div>
                    `;
                  },
                },
                colors: ["#50b585", "#795ecc", "#f54962"],
              }}
            />
          </Col>
        </Row>

        <Row className="mt-2">
          <Col xs={12} lg={4} className="analytics-card mt-2 p-0 pr-lg-2">
            <ItemRanking
              className="card h-100"
              header="Popular Items"
              params={{ ...params, limit: 4 }}
            >
              <h4 className="pt-8 px-8">Popular Items</h4>
            </ItemRanking>
          </Col>
          <Col xs={12} lg={4} className="analytics-card mt-2 p-0 pl-lg-2">
            <ItemRanking
              className="h-100"
              header="Least Popular Items"
              params={{ ...params, limit: 4, sort: 1 }}
            >
              <h4 className="pt-8 px-8">Least Popular Items</h4>
            </ItemRanking>
          </Col>
          {/* <Col xs={12} lg={4} className="px-0 px-lg-4 overflow-hidden rounded"> */}
          <Col xs={12} lg={4} className="analytics-card mt-2 p-0 px-lg-4">
            <CustomerMix params={params} data_url="/dashboard/customer-mix" />
          </Col>
        </Row>

        <Row className="mt-2">
          <Col xs={12} className="analytics-card mt-2 p-0 pr-lg-4">
            <SalesPerItemCard params={params} />
          </Col>
        </Row>

        <Row className="mt-2">
          <Col
            xs={12}
            lg={4}
            className="d-flex flex-column align-items-stretch analytics-card mt-2 p-0 pr-lg-2"
          >
            <CardList
              params={{ ...params, isTotalVisible: true, excludeDeliveryFee }}
              className="card card-custom"
              header={"Sales by Payment Type"}
              mapFunction={(item) =>
                item.sales !== 0 && (
                  <li
                    className="d-flex justify-content-between align-items-center py-1 px-2"
                    key={item._id}
                  >
                    <img
                      style={cardListItemImgStyling}
                      className="img-fluid mx-auto"
                      src={`/media/logos/payment/${item._id}.png`}
                      alt={item._id}
                    />
                    <span>{toPesoAmount(item.sales)}</span>
                  </li>
                )
              }
            />
          </Col>
          <Col xs={12} lg={4} className="analytics-card p-0 pl-lg-2 mt-2">
            <CardList
              params={params}
              className="card card-custom"
              header={"Payment Type by Usage"}
              mapFunction={(item, idx, items) => (
                <li
                  className="d-flex justify-content-between align-items-center py-1 px-2"
                  key={item._id}
                >
                  <img
                    style={cardListItemImgStyling}
                    className="img-fluid mx-auto"
                    src={`/media/logos/payment/${item._id}.png`}
                    alt={item._id}
                  />
                  <span>
                    {(
                      (item.instance /
                        items.reduce((a, b) => a + b.instance, 0)) *
                      100
                    ).toFixed(2)}
                    %
                  </span>
                </li>
              )}
            />
          </Col>
          <Col
            xs={12}
            lg={4}
            className="px-0 px-lg-4 rounded mt-2 analytics-card"
          >
            <CardListByReferrer
              params={{
                ...params,
                isTotalVisible: true,
                excludeDeliveryFee,
              }}
              className="card card-custom"
              header={"Sales by Source"}
              mapFunction={(item) =>
                item.sales !== 0 && (
                  <li
                    className="d-flex justify-content-between align-items-center py-1 px-2"
                    key={item._id}
                  >
                    <span>{item._id}</span>
                    <span>{toPesoAmount(item.sales)}</span>
                  </li>
                )
              }
              data={data}
              onSourceNameSubmit={onSourceNameSubmit}
              stores={store_options}
              isBrand={props.selectedBrand.attr === "brand"}
              isLoading={isLoading}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AnalyticsGrid;
